import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useLanguage, LangToggle } from '../context/LanguageContext'

export default function Login() {
  const { t } = useLanguage()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [mode, setMode] = useState('login')
  const [successMsg, setSuccessMsg] = useState('')

  const handleLogin = async () => {
    setLoading(true); setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(t.invalidCredentials)
    setLoading(false)
  }

  const handleResetPassword = async () => {
    if (!email) return setError(t.enterEmailFirst)
    setLoading(true); setError('')
    const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: 'https://damanati.co/profile' })
    setLoading(false)
    if (error) return setError(error.message)
    setSuccessMsg('✓')
  }

  const handleMagicLink = async () => {
    if (!email) return setError(t.enterEmailFirst)
    setLoading(true); setError('')
    const { error } = await supabase.auth.signInWithOtp({ email, options: { emailRedirectTo: 'https://damanati.co/dashboard' } })
    setLoading(false)
    if (error) return setError(error.message)
    setSuccessMsg('✓')
  }

  const resetState = (newMode) => { setMode(newMode); setError(''); setSuccessMsg('') }

  return (
    <div className="auth-page">
      <div className="auth-box">

        {/* Lang toggle — top right of card */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
          <LangToggle />
        </div>

        <div className="auth-logo">
          <span style={{ color: '#E8610A', fontWeight: 900, fontSize: '1.1rem' }}>{t.appName} 🛡️</span>
        </div>

        {/* ── LOGIN ── */}
        {mode === 'login' && (
          <>
            <h1 className="auth-title">{t.welcomeBack}</h1>
            <p className="auth-sub">{t.loginSub}</p>
            {error && <div className="error-msg">{error}</div>}
            <div className="form-group">
              <label className="form-label" htmlFor="login-email">{t.emailLabel}</label>
              <input className="form-input" id="login-email" type="email" placeholder="example@email.com" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="login-password">{t.passwordLabel}</label>
              <input className="form-input" id="login-password" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} />
            </div>
            <button className="btn-full" onClick={handleLogin} disabled={loading}>
              {loading ? t.loggingIn : t.loginBtn}
            </button>
            <div style={{ textAlign: 'center', marginTop: 14 }}>
              <button className="link-btn" onClick={() => resetState('reset')}>{t.forgotPassword}</button>
            </div>
            <div className="auth-divider"><span>{t.orDivider}</span></div>
            <button className="btn-outline" onClick={() => resetState('magic')}>{t.magicLinkBtn}</button>
            <div className="auth-switch">{t.noAccount} <Link to="/register">{t.createAccountLink}</Link></div>
          </>
        )}

        {/* ── RESET ── */}
        {mode === 'reset' && (
          <>
            <h1 className="auth-title">{t.resetTitle}</h1>
            <p className="auth-sub">{t.resetSub}</p>
            {error && <div className="error-msg">{error}</div>}
            {successMsg && <div className="success-msg">{successMsg}</div>}
            {!successMsg && (
              <>
                <div className="form-group">
                  <label className="form-label" htmlFor="reset-email">{t.emailLabel}</label>
                  <input className="form-input" id="reset-email" type="email" placeholder="example@email.com" value={email} onChange={e => setEmail(e.target.value)} />
                </div>
                <button className="btn-full" onClick={handleResetPassword} disabled={loading}>
                  {loading ? t.sending : t.sendReset}
                </button>
              </>
            )}
            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <button className="link-btn" onClick={() => resetState('login')}>{t.backToLogin}</button>
            </div>
          </>
        )}

        {/* ── MAGIC LINK ── */}
        {mode === 'magic' && (
          <>
            <h1 className="auth-title">{t.magicTitle}</h1>
            <p className="auth-sub">{t.magicSub}</p>
            {error && <div className="error-msg">{error}</div>}
            {successMsg && <div className="success-msg">{successMsg}</div>}
            {!successMsg && (
              <>
                <div className="form-group">
                  <label className="form-label" htmlFor="magic-email">{t.emailLabel}</label>
                  <input className="form-input" id="magic-email" type="email" placeholder="example@email.com" value={email} onChange={e => setEmail(e.target.value)} />
                </div>
                <button className="btn-full" onClick={handleMagicLink} disabled={loading}>
                  {loading ? t.sending : t.sendMagic}
                </button>
              </>
            )}
            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <button className="link-btn" onClick={() => resetState('login')}>{t.backToLogin}</button>
            </div>
          </>
        )}

      </div>
    </div>
  )
}
